import React, { useEffect } from 'react';
import { StyledModal } from './styled';
import Carousel, { Slide } from '../common/Carousel';
import { showTourAtom } from '@src/atoms/quickTour';
import { useAtom } from 'jotai';

const slides: Slide[] = [
  {
    id: 1,
    image: 'https://ca-stg1.viewer.conviva.com/pulse_static/quick_tour/active_user/1.png',
    title: 'Quick tour: Identify Issues, Benchmark Success with QoE Index Widget',
    description:
      'Transition from Summary to Detailed Cohort Analysis view (by selecting the widget specific view).',
    type: 'image',
  },
  {
    id: 2,
    image: 'https://ca-stg1.viewer.conviva.com/pulse_static/quick_tour/active_user/2.png',
    title: 'Quick tour: Identify Issues, Benchmark Success with QoE Index Widget',
    description: 'Add/Remove Metrics and Dimensions to understand what issues.',
    type: 'gif',
  },
  {
    id: 3,
    image: 'https://ca-stg1.viewer.conviva.com/pulse_static/quick_tour/active_user/3.gif',
    title: 'Quick tour: Identify Issues, Benchmark Success with QoE Index Widget',
    description:
      'Easily perform advanced dimensional drill-downs to identify opportunities and to build performance benchmarks!',
    type: 'gif',
  },
];

const QuickTour = () => {
  const [isModalOpen, setIsModalOpen] = useAtom(showTourAtom);

  useEffect(() => {
    const handleEvent = (e: CustomEvent) => {
      const { open, source } = e.detail || {};
      if (source === 'SelfServeQuickTourButton') {
        setIsModalOpen(open);
      }
    };

    window.addEventListener('open-quick-tour-modal', handleEvent as EventListener);

    return () => {
      window.removeEventListener('open-quick-tour-modal', handleEvent as EventListener);
    };
  }, [setIsModalOpen]);

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <StyledModal open={isModalOpen} onCancel={handleCancel} footer={null} width={1250} centered>
      <Carousel slides={slides} indexStyle="rectangle" />
    </StyledModal>
  );
};

export default QuickTour;
